/* ==========================================================================
   Cloud Store CBD — Page fidélité (/pages/fidelite)
   - Init Smile.js avec publishable key
   - Affiche balance live + progression vers chaque récompense
   - Lien parrainage copyable
   - Bouton "Échanger mes points" → ouvre le panneau Smile (seul moment où on
     l'expose, en deep-link points_products)
   ========================================================================== */

(function () {
  'use strict';
  if (window.__csLoyaltyInit) return;
  window.__csLoyaltyInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var data = window.__csLoyaltyData || {};

    /* ===== DOM hooks ===== */
    var balanceBlock = document.querySelector('[data-cs-loyalty-balance]');
    var pointsEl = document.querySelector('[data-cs-loyalty-points]');
    var eurEl = document.querySelector('[data-cs-loyalty-eur]');
    var barEl = document.querySelector('[data-cs-loyalty-bar]');
    var nextEl = document.querySelector('[data-cs-loyalty-next]');
    var loginHint = document.querySelector('[data-cs-loyalty-loginhint]');
    var rewardCards = document.querySelectorAll('[data-cs-reward]');
    var refBlock = document.querySelector('[data-cs-loyalty-referral-block]');
    var refInput = document.querySelector('[data-cs-loyalty-referral-input]');
    var refCopy = document.querySelector('[data-cs-loyalty-referral-copy]');
    var refFeedback = document.querySelector('[data-cs-loyalty-referral-feedback]');
    var refLoading = document.querySelector('[data-cs-loyalty-referral-loading]');
    var openSmileBtn = document.querySelector('[data-cs-loyalty-open-smile]');
    var stickyBar = document.querySelector('[data-cs-loyalty-sticky]');
    var stickyPoints = document.querySelector('[data-cs-loyalty-sticky-points]');
    var stickyEur = document.querySelector('[data-cs-loyalty-sticky-eur]');
    var shareWa = document.querySelector('[data-cs-loyalty-share-whatsapp]');
    var shareSms = document.querySelector('[data-cs-loyalty-share-sms]');
    var shareMail = document.querySelector('[data-cs-loyalty-share-mail]');
    var shareFb = document.querySelector('[data-cs-loyalty-share-fb]');
    var hero = document.querySelector('.cs-loyalty__hero');

    var REDEEM_RATIO = 20; // 20 pts = 1 €

    function renderBalance(points) {
      var p = parseInt(points, 10) || 0;
      var eur = (p / REDEEM_RATIO).toFixed(2).replace('.', ',');
      if (balanceBlock) balanceBlock.removeAttribute('hidden');
      if (pointsEl) pointsEl.textContent = p;
      if (eurEl) eurEl.textContent = eur;
      /* Sticky bar : même contenu */
      if (stickyPoints) stickyPoints.textContent = p;
      if (stickyEur) stickyEur.textContent = eur;
      window.__csLoyaltyBalanceLoaded = true;

      /* Trouve le prochain palier déverrouillable */
      var tiers = [100, 200, 500, 1000];
      var nextTier = tiers.find(function (t) { return p < t; }) || tiers[tiers.length - 1];
      var pct = Math.min(100, Math.round((p / nextTier) * 100));
      if (barEl) barEl.style.width = pct + '%';
      if (nextEl) {
        if (p >= 1000) {
          nextEl.innerHTML = '🎉 Tu as atteint le palier max — échange tes points dès que tu veux !';
        } else {
          var remaining = nextTier - p;
          nextEl.innerHTML = 'Plus que <b>' + remaining + ' pts</b> pour débloquer <b>' + (nextTier / REDEEM_RATIO) + ' €</b> de réduction.';
        }
      }

      /* Met à jour chaque carte récompense */
      rewardCards.forEach(function (card) {
        var threshold = parseInt(card.getAttribute('data-cs-reward'), 10) || 0;
        var bar = card.querySelector('[data-cs-reward-bar]');
        var status = card.querySelector('[data-cs-reward-status]');
        var cardPct = Math.min(100, Math.round((p / threshold) * 100));
        if (bar) bar.style.width = cardPct + '%';
        if (status) {
          if (p >= threshold) {
            status.textContent = '✓ Débloqué — à échanger !';
            status.classList.add('is-unlocked');
          } else {
            status.textContent = (threshold - p) + ' pts restants';
            status.classList.remove('is-unlocked');
          }
        }
      });

      if (loginHint) loginHint.style.display = 'none';
    }

    function renderReferral(url) {
      if (!refBlock || !url) return;
      refBlock.removeAttribute('hidden');
      if (refInput) refInput.value = url;
      if (refLoading) refLoading.style.display = 'none';

      /* Pré-remplit les boutons partage avec le lien perso */
      var shareText = "Salut ! Profite de -20 % sur ta première commande Cloud Store CBD avec mon lien : ";
      var fullText = shareText + url;
      if (shareWa) shareWa.href = "https://wa.me/?text=" + encodeURIComponent(fullText);
      if (shareSms) shareSms.href = "sms:?&body=" + encodeURIComponent(fullText);
      if (shareMail) shareMail.href = "mailto:?subject=" + encodeURIComponent("-20% sur Cloud Store CBD 🌥") + "&body=" + encodeURIComponent(fullText);
      if (shareFb) shareFb.href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
    }

    /* ===== Sticky bar : visible quand le hero sort de l'écran ===== */
    function setupSticky() {
      if (!stickyBar || !hero) return;
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /* Hero hors écran ET balance chargée → on affiche la sticky */
          if (!entry.isIntersecting && window.__csLoyaltyBalanceLoaded) {
            stickyBar.removeAttribute('hidden');
            requestAnimationFrame(function () { stickyBar.classList.add('is-visible'); });
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
      io.observe(hero);
    }
    setupSticky();

    /* ===== Copier lien parrainage ===== */
    if (refCopy && refInput) {
      refCopy.addEventListener('click', function () {
        if (!refInput.value) return;
        var done = function () {
          if (refFeedback) {
            refFeedback.textContent = '✓ Lien copié dans ton presse-papier !';
            setTimeout(function () { if (refFeedback) refFeedback.textContent = ''; }, 3000);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(refInput.value).then(done, function () {
            refInput.select(); document.execCommand('copy'); done();
          });
        } else {
          refInput.select(); document.execCommand('copy'); done();
        }
      });
    }

    /* ===== Bouton "Échanger mes points" → ouvre le panneau Smile ===== */
    function openSmilePanel() {
      try {
        if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
          window.SmileUI.openPanel({ deep_link: 'points_products' });
          return true;
        }
      } catch (e) {}
      return false;
    }
    if (openSmileBtn) {
      openSmileBtn.addEventListener('click', function () {
        if (openSmilePanel()) return;
        /* Polling fallback : Smile UI charge en différé */
        var attempts = 0;
        openSmileBtn.disabled = true;
        var oldText = openSmileBtn.textContent;
        openSmileBtn.textContent = 'Chargement…';
        var iv = setInterval(function () {
          attempts++;
          if (openSmilePanel()) {
            clearInterval(iv);
            openSmileBtn.disabled = false;
            openSmileBtn.textContent = oldText;
            return;
          }
          if (attempts >= 40) {
            clearInterval(iv);
            openSmileBtn.disabled = false;
            openSmileBtn.textContent = oldText;
            /* Fallback : reload avec query param */
            var url = new URL(window.location.href);
            url.searchParams.set('smile_deep_link', 'points_products');
            window.location.href = url.toString();
          }
        }, 200);
      });
    }

    /* ===== Boot Smile.js (balance + référral) ===== */
    function bootSmile() {
      try {
        if (typeof window.Smile === 'undefined' || typeof window.Smile.initialize !== 'function') return;
        if (!data.smileChannelKey) return;
        if (window.__csLoyaltySmileInit) return;
        window.__csLoyaltySmileInit = true;

        window.Smile.initialize({
          publishableKey: data.smileChannelKey,
          preload: ['pointsSettings']
        }).catch(function () {});

        document.addEventListener('smile-js-initialized', function () {
          /* Balance */
          if (window.Smile.customerPointsWallet && typeof window.Smile.customerPointsWallet.get === 'function') {
            window.Smile.customerPointsWallet.get().then(function (wallet) {
              if (wallet && typeof wallet.pointsBalance !== 'undefined') {
                renderBalance(wallet.pointsBalance);
              } else if (typeof wallet === 'number') {
                renderBalance(wallet);
              }
            }).catch(function () {});
          }
          /* Customer info → referral URL */
          if (window.Smile.customer && typeof window.Smile.customer.current === 'function') {
            window.Smile.customer.current().then(function (cust) {
              if (cust && cust.referralUrl) renderReferral(cust.referralUrl);
              else if (refLoading) refLoading.textContent = "Connecte-toi à Smile pour récupérer ton lien.";
            }).catch(function () {
              if (refLoading) refLoading.textContent = "Lien non disponible pour le moment.";
            });
          }
        });
      } catch (e) {}
    }

    if (typeof window.Smile !== 'undefined') {
      bootSmile();
    } else {
      document.addEventListener('smile-js-loaded', bootSmile);
      setTimeout(bootSmile, 2500);
    }

    /* Si SDK Smile n'est pas chargé sur cette page, on charge le script à la volée */
    if (!document.querySelector('script[src*="smile-js"]') && data.smileChannelKey) {
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://sdk.smile.io/smile-js/v1/smile.js';
      document.head.appendChild(s);
    }
  });
})();
